<template>
    <div class="dropdown"
        :class="{'is-active': show_dropdown}"
        @mouseleave="show_dropdown = false"
        @dragenter.stop="is_drag_enter = true"
        @dragleave.stop="is_drag_enter = false"
        @dragover.stop="$event.preventDefault()"
        @drop.prevent.stop="drop">

        <router-link
            :to="{name: 'flow', params: {space: space.id, flow: flow.id}}"
            :class="{'is-active': is_drag_enter}"
            class="flow menu-item"
            exact>

            <i class="icon fas fa-columns"></i>

            {{flow.name}}

            <i v-if="space_permission('FLOW_UPDATE') || space_permission('FLOW_DELETE')"
               @click.prevent.stop="show_dropdown = !show_dropdown"
               class="icon fas fa-ellipsis-v is-pulled-right"></i>
        </router-link>

        <div class="dropdown-menu">
            <div class="dropdown-content">
                <a v-if="space_permission('FLOW_UPDATE')"
                   @click="show_edit_modal"
                   class="dropdown-item">

                    <i class="icon fas fa-pen"></i> Edit
                </a>

                <a v-if="space_permission('FLOW_DELETE')"
                   @click="show_confirm = true"
                   class="dropdown-item">

                    <i class="icon fas fa-trash-alt"></i> Delete
                </a>
            </div>
        </div>

        <flow-update-modal
            v-if="show_edit"
            @close="show_edit = false"
            :space="space"
            :flow="flow"/>

        <base-confirm-modal
            v-if="show_confirm"
            text="Do you really want to remove this Flow?"
            @close="show_confirm = false"
            @ok="remove_flow"/>

        <base-confirm-modal
            v-if="show_move_note_confirm"
            :text='move_error_message'
            :loading="card_update.loading"
            @close="show_move_note_confirm = false"
            @ok="move_card"/>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import FlowUpdateModal from './FlowUpdateModal.vue';

export default {
    name: 'FlowsListItem',
    components: { FlowUpdateModal },
    props: ['space', 'flow'],
    computed: {
        ...mapState('tree', ['moving_element']),
        ...mapState('cards', { card_update: 'update', card_create: 'create' }),
        move_error_message() {
            return `This note already exists in "${this.card_create.error.flow.name}".
                    Do you want to move?`;
        },
    },
    data() {
        return {
            show_edit: false,
            show_confirm: false,
            show_dropdown: false,
            is_drag_enter: false,
            show_move_note_confirm: false,
        };
    },
    methods: {
        remove_flow() {
            this.$store.dispatch('flows/remove', {
                space_id: this.space.id,
                flow_id: this.flow.id,
            }).then(() => {
                this.$store.dispatch('flows/list', { space_id: this.space.id });
            });
        },
        show_edit_modal() {
            this.show_edit = true;
            this.show_dropdown = false;
        },
        drop() {
            this.is_drag_enter = false;

            if (this.moving_element.kind !== 'note') {
                return;
            }

            this.$store.dispatch('cards/create', {
                space_id: this.space.id,
                flow_id: this.flow.id,
                data: { notes: [this.moving_element.id], is_open: true },
            }).catch(() => {
                this.show_move_note_confirm = true;
            });
        },
        async move_card() {
            await this.$store.dispatch('cards/update', {
                space_id: this.space.id,
                flow_id: this.card_create.error.flow.id,
                card_id: this.card_create.error.card.id,
                data: { flow: this.flow.id, column: null, is_open: true },
            });

            this.show_move_note_confirm = false;
        },
    },
};
</script>

<style scoped>
    .flow .fa-ellipsis-v {
        display: none;
        position: absolute;
        right: 0;
    }

    .flow:hover .fa-ellipsis-v {
        display: -ms-inline-flexbox;
        display: inline-flex;
    }
</style>
